import moment from "moment";

export const formatRescheduleDate = (datetime: string) =>
  moment(datetime).format("YYYY-MM-DD HH:mm:ss");

type OrderStatusFlag = {
  fill: string;
  stroke: string;
  label: string;
};

const ORDER_STATUS_FLAGS: Record<string, OrderStatusFlag> = {
  ON_TIME: {
    fill: "rgb(74, 222, 128)",
    stroke: "rgb(21, 128, 61)",
    label: "No prazo",
  },
  DUE_TODAY: {
    fill: "rgb(250, 204, 21)",
    stroke: "rgb(161, 98, 7)",
    label: "Vence hoje",
  },
  OVERDUE: {
    fill: "rgb(248, 113, 113)",
    stroke: "rgb(185, 28, 28)",
    label: "Atrasado",
  },
  SENT: {
    fill: "rgb(192, 132, 252)",
    stroke: "rgb(126, 34, 206)",
    label: "Enviado",
  },
};

const DEFAULT_ORDER_STATUS_FLAG: OrderStatusFlag = {
  fill: "#d9d9d9",
  stroke: "#a3a3a3",
  label: "Sem status",
};

export const getOrderStatusFlag = (status?: string | null) =>
  (status && ORDER_STATUS_FLAGS[status]) || DEFAULT_ORDER_STATUS_FLAG;
